import './PartReCategorizationComponent.scss';
import React from "react";
import {ExpandMore} from "@mui/icons-material";
import {ButtonBase, Chip, Stack, Tooltip} from "@mui/material";
import ChevronIcon from "~/icons/svg/ChevronIcon.svg?react";
import {UNCATEGORIZED_LABEL, UNCATEGORIZED_VALUE} from "../../constants";
import {
    categoryChipArrowStyle,
    categoryChipMaxWidth,
    doCategoryChipEllipsis,
    getCategoryChipSx,
} from "./categoryChip.utils.ts";
import {DEFAULT_CATEGORY_COL_WIDTH} from "../../stores/ProfileStore.tsx";

type Props = {
    cats: string[] | false
    handleOpenSearch: (event: React.MouseEvent<HTMLButtonElement>) => void
    selectedL1Category: string | undefined,
    colWidth?: number,
}
export const PartReCategorizationComponent: React.FC<Props> = ({
                                                                   cats,
                                                                   handleOpenSearch,
                                                                   selectedL1Category,
                                                                   colWidth
                                                               }) => {
    const catsIsUncategorized = cats === false || cats.every(c => c === UNCATEGORIZED_VALUE); // | cats.length === 0
    const isNoCategory = cats !== false && cats.length === 0;
    const columnWidth = colWidth ?? DEFAULT_CATEGORY_COL_WIDTH;
    const chipCount = Array.isArray(cats) ? cats.length : 3;
    const chipMaxWidth = categoryChipMaxWidth(columnWidth, chipCount);

    return <div className="part-recat-component">
        <ButtonBase onClick={handleOpenSearch}>
            {isNoCategory
                ? <Chip
                    variant="outlined"
                    color="primary"
                    size="small"
                    deleteIcon={<ExpandMore/>}
                    onDelete={handleOpenSearch}
                    label="Change all categories for supplier"
                    sx={getCategoryChipSx()}
                />
                : catsIsUncategorized
                    ? <Chip
                        variant="outlined"
                        color="primary"
                        size="small"
                        deleteIcon={<ExpandMore/>}
                        onDelete={handleOpenSearch}
                        label={UNCATEGORIZED_LABEL}
                        sx={getCategoryChipSx()}
                    />
                    : <Stack
                        direction="row"
                        flexWrap="wrap"
                        alignItems="center"
                        gap="4px"
                    >
                        {(cats as string[]).map((c, i) => {
                            const categoryLabel = c === UNCATEGORIZED_VALUE ? UNCATEGORIZED_LABEL : c;
                            const [s, cutoff] = doCategoryChipEllipsis(categoryLabel, chipMaxWidth);
                            const chip = <Chip
                                variant="outlined"
                                color={selectedL1Category === c ? "secondary" : "default"}
                                size="small"
                                deleteIcon={(i === (cats as string[]).length - 1) ? <ExpandMore/> : undefined}
                                onDelete={(i === (cats as string[]).length - 1) ? handleOpenSearch : undefined}
                                label={s}
                                sx={getCategoryChipSx(chipMaxWidth)}
                            />;
                            return <React.Fragment key={i}>
                                {cutoff
                                    ? <Tooltip title={categoryLabel}>{chip}</Tooltip>
                                    : chip}
                                {(i < (cats as string[]).length - 1) &&
                                    <ChevronIcon style={categoryChipArrowStyle} fontSize="small"/>}
                            </React.Fragment>;
                        })}
                    </Stack>
            }
        </ButtonBase>
    </div>;
}
